const IAM_MIN_PASS_LENGTH = 6
const IAM_MAX_PASS_LENGTH = 8

export const passwordLengthValidation = (password: string) =>
	password.length >= IAM_MIN_PASS_LENGTH &&
	password.length <= IAM_MAX_PASS_LENGTH

export const passwordFontCaseValidation = (password: string) => {
	const upperCaseRegex = /[A-Z]/g
	const lowerCaseRegex = /[a-z]/g

	return upperCaseRegex.test(password) && lowerCaseRegex.test(password)
}

export const passwordNumberValidation = (password: string) => {
	const numberRegex = /[0-9]/g
	return numberRegex.test(password)
}

export const passwordSpecialCharValidation = (password: string) => {
	const numberRegex = /[#?!@$ %^&*-._,]/g
	return numberRegex.test(password)
}

export const validateCriteria = (password: string) => ({
	hasLength: passwordLengthValidation(password),
	hasCap: passwordFontCaseValidation(password),
	hasNumber: passwordNumberValidation(password),
	hasSpecialChar: passwordSpecialCharValidation(password),
})
